import { EDA } from "motw_core/Dreams/EDreamAttribute";
import * as React from "react";
import {
    DynamicNewDreamLink,
    GetSelectedDreamAttribute,
    ProblemNewDreamLink,
    RegularNewDreamLink,
} from "source/app/presentation/MainPanel/Dreams/Add/NewDream/Link/ShowNewDreamLink";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";

export function NewDreamLinks({ dreamsState }: { dreamsState: IDreamsState }) {
    return (
        <div style={{ margin: `10px 0px` }}>
            <ProblemNewDreamLink {...{ dreamsState }} />
            {GetSelectedDreamAttribute(dreamsState) !== EDA.problem && (
                <DynamicNewDreamLink {...{ dreamsState }} />
            )}
            <RegularNewDreamLink {...{ dreamsState }} />
        </div>
    );
}
